export const getUserNameAndSurnameLetter = (name: string, surname: string) => {
  const result = name.charAt(0).toUpperCase() + surname.charAt(0).toUpperCase();
  return result;
};
